export const Goal_Svg = () => (
  <svg
    id="bar-chart"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_2531" data-name="Group 2531">
      <g id="Group_2530" data-name="Group 2530">
        <rect
          id="Rectangle_892"
          data-name="Rectangle 892"
          width="24"
          height="0.8"
          transform="translate(0 23.2)"
          fill="#fff"
        />
        <path
          id="Path_4328"
          data-name="Path 4328"
          d="M24.4,296h4a.4.4,0,0,0,.4-.4v-7.2a.4.4,0,0,0-.4-.4h-4a.4.4,0,0,0-.4.4v7.2A.4.4,0,0,0,24.4,296Zm.4-7.2H28v6.4H24.8Z"
          transform="translate(-22.8 -273.6)"
          fill="#fff"
        />
        <path
          id="Path_4329"
          data-name="Path 4329"
          d="M248.4,204.8h4a.4.4,0,0,0,.4-.4v-12a.4.4,0,0,0-.4-.4h-4a.4.4,0,0,0-.4.4v12A.4.4,0,0,0,248.4,204.8Zm.4-12H252V204h-3.2Z"
          transform="translate(-235.6 -182.4)"
          fill="#fff"
        />
        <path
          id="Path_4330"
          data-name="Path 4330"
          d="M136.4,113.6h4a.4.4,0,0,0,.4-.4V96.4a.4.4,0,0,0-.4-.4h-4a.4.4,0,0,0-.4.4v16.8A.4.4,0,0,0,136.4,113.6Zm.4-16.8H140v16h-3.2Z"
          transform="translate(-129.2 -91.2)"
          fill="#fff"
        />
        <path
          id="Path_4331"
          data-name="Path 4331"
          d="M360.4,22.4h4a.4.4,0,0,0,.4-.4V.4a.4.4,0,0,0-.4-.4h-4a.4.4,0,0,0-.4.4V22A.4.4,0,0,0,360.4,22.4ZM360.8.8H364V21.6h-3.2Z"
          transform="translate(-342 0)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);

export const CurrentStatus_Svg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.001"
    height="24"
    viewBox="0 0 24.001 24"
  >
    <g id="mission" transform="translate(0)">
      <path
        id="Path_4324"
        data-name="Path 4324"
        d="M18.5,24H.5a.5.5,0,0,1-.439-.74l9-16.5a.521.521,0,0,1,.878,0l9,16.5A.5.5,0,0,1,18.5,24ZM1.342,23H17.657L9.5,8.044Z"
        fill="#fff"
      />
      <path
        id="Path_4325"
        data-name="Path 4325"
        d="M23.5,24h-5a.5.5,0,0,1,0-1h4.154l-4.625-8.41-1.906,3.944a.5.5,0,0,1-.9-.436l2.328-4.816A.5.5,0,0,1,17.988,13a.526.526,0,0,1,.451.259l5.5,10A.5.5,0,0,1,23.5,24Z"
        fill="#fff"
      />
      <path
        id="Path_4326"
        data-name="Path 4326"
        d="M9.5,7.5A.5.5,0,0,1,9,7V.5A.5.5,0,0,1,9.5,0h6a.5.5,0,0,1,.354.854L14.207,2.5l1.646,1.646A.5.5,0,0,1,15.5,5H10V7a.5.5,0,0,1-.5.5ZM10,4h4.293L13.147,2.854a.5.5,0,0,1,0-.707L14.293,1H10Z"
        fill="#fff"
      />
      <path
        id="Path_4327"
        data-name="Path 4327"
        d="M11,15h-.036a.5.5,0,0,1-.364-.2L9.5,13.334,8.4,14.8a.5.5,0,0,1-.364.2.483.483,0,0,1-.389-.145l-1.68-1.68a.5.5,0,0,1,.707-.707l1.272,1.272L9.1,12.2a.518.518,0,0,1,.8,0l1.154,1.539,1.272-1.272a.5.5,0,0,1,.707.707l-1.68,1.68A.5.5,0,0,1,11,15Z"
        fill="#fff"
      />
    </g>
  </svg>
);

export const Challenges_Svg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <defs>
      <clipPath id="clipPath">
        <path
          id="path1548"
          d="M0-682.665H24v24H0Z"
          transform="translate(0 682.665)"
          fill="#fff"
        />
      </clipPath>
    </defs>
    <g id="g1542" transform="translate(0 682.665)">
      <g id="g1544" transform="translate(0 -682.665)">
        <g id="g1546" transform="translate(0 0)" clipPath="url(#clipPath)">
          <g id="g1552" transform="translate(2.883 6.437)">
            <path
              id="path1554"
              d="M-491.72-364.9h-15.656a1.291,1.291,0,0,1-1.289-1.289v-15.922a.352.352,0,0,1,.352-.352.352.352,0,0,1,.352.352v15.922a.587.587,0,0,0,.586.586h15.656a.587.587,0,0,0,.586-.586v-2.828a.352.352,0,0,1,.352-.352.352.352,0,0,1,.352.352v2.828A1.291,1.291,0,0,1-491.72-364.9Z"
              transform="translate(508.665 382.464)"
              fill="#fff"
            />
          </g>
          <g id="g1556" transform="translate(17.697 0)">
            <path
              id="path1558"
              d="M-6.931,8.573a.352.352,0,0,1-.352-.352V-8.711A.587.587,0,0,0-7.869-9.3h-1.78A.352.352,0,0,1-10-9.648.352.352,0,0,1-9.648-10h1.78A1.291,1.291,0,0,1-6.58-8.711V8.222A.352.352,0,0,1-6.931,8.573Z"
              transform="translate(10 10)"
              fill="#fff"
            />
          </g>
          <g id="g1560" transform="translate(2.883 0)">
            <path
              id="path1562"
              d="M-9.648-138.925a.352.352,0,0,1-.352-.352v-3.786a1.291,1.291,0,0,1,1.289-1.289H3.53a.352.352,0,0,1,.352.352.352.352,0,0,1-.352.352H-8.711a.587.587,0,0,0-.586.586v3.786A.352.352,0,0,1-9.648-138.925Z"
              transform="translate(10 144.352)"
              fill="#fff"
            />
          </g>
          <g id="g1564" transform="translate(13.805 4.801)">
            <path
              id="path1566"
              d="M-140.638-76.666a2.7,2.7,0,0,1,2.7,2.7,2.7,2.7,0,0,1-2.7,2.7,2.7,2.7,0,0,1-2.7-2.7A2.7,2.7,0,0,1-140.638-76.666Zm0,4.688a1.994,1.994,0,0,0,1.992-1.992,1.994,1.994,0,0,0-1.992-1.992,1.994,1.994,0,0,0-1.992,1.992A1.994,1.994,0,0,0-140.638-71.979Z"
              transform="translate(143.333 76.666)"
              fill="#fff"
            />
          </g>
          <g id="g1568" transform="translate(15.141 6.45)">
            <path
              id="path1570"
              d="M-8.658-31.585a.35.35,0,0,1-.166-.042l-.993-.533a.352.352,0,0,1-.143-.476.352.352,0,0,1,.476-.143l.707.38.708-1.093a.352.352,0,0,1,.486-.1.352.352,0,0,1,.1.486l-.884,1.365A.351.351,0,0,1-8.658-31.585Z"
              transform="translate(10.002 33.653)"
              fill="#fff"
            />
          </g>
          <g id="g1572" transform="translate(13.805 10.945)">
            <path
              id="path1574"
              d="M-140.638-76.666a2.7,2.7,0,0,1,2.7,2.7,2.7,2.7,0,0,1-2.7,2.7,2.7,2.7,0,0,1-2.7-2.7A2.7,2.7,0,0,1-140.638-76.666Zm0,4.688a1.994,1.994,0,0,0,1.992-1.992,1.994,1.994,0,0,0-1.992-1.992,1.994,1.994,0,0,0-1.992,1.992A1.994,1.994,0,0,0-140.638-71.979Z"
              transform="translate(143.333 76.666)"
              fill="#fff"
            />
          </g>
          <g id="g1576" transform="translate(15.141 12.594)">
            <path
              id="path1578"
              d="M-8.658-31.585a.35.35,0,0,1-.166-.042l-.993-.533a.352.352,0,0,1-.143-.476.352.352,0,0,1,.476-.143l.707.38.708-1.093a.352.352,0,0,1,.486-.1.352.352,0,0,1,.1.486l-.884,1.365A.351.351,0,0,1-8.658-31.585Z"
              transform="translate(10.002 33.653)"
              fill="#fff"
            />
          </g>
          <g id="g1580" transform="translate(13.805 17.089)">
            <path
              id="path1582"
              d="M-140.638-76.666a2.7,2.7,0,0,1,2.7,2.7,2.7,2.7,0,0,1-2.7,2.7,2.7,2.7,0,0,1-2.7-2.7A2.7,2.7,0,0,1-140.638-76.666Zm0,4.688a1.994,1.994,0,0,0,1.992-1.992,1.994,1.994,0,0,0-1.992-1.992,1.994,1.994,0,0,0-1.992,1.992A1.994,1.994,0,0,0-140.638-71.979Z"
              transform="translate(143.333 76.666)"
              fill="#fff"
            />
          </g>
          <g id="g1584" transform="translate(15.141 18.738)">
            <path
              id="path1586"
              d="M-8.658-31.585a.35.35,0,0,1-.166-.042l-.993-.533a.352.352,0,0,1-.143-.476.352.352,0,0,1,.476-.143l.707.38.708-1.093a.352.352,0,0,1,.486-.1.352.352,0,0,1,.1.486l-.884,1.365A.351.351,0,0,1-8.658-31.585Z"
              transform="translate(10.002 33.653)"
              fill="#fff"
            />
          </g>
          <g id="g1588" transform="translate(2.965 3.258)">
            <path
              id="path1590"
              d="M7.719-9.3H-9.648A.352.352,0,0,1-10-9.648.352.352,0,0,1-9.648-10H7.719a.352.352,0,0,1,.352.352A.352.352,0,0,1,7.719-9.3Z"
              transform="translate(10 10)"
              fill="#fff"
            />
          </g>
          <g id="g1592" transform="translate(5.191 6.271)">
            <path
              id="path1594"
              d="M-4.023-9.3H-9.648A.352.352,0,0,1-10-9.648.352.352,0,0,1-9.648-10h5.625a.352.352,0,0,1,.352.352A.352.352,0,0,1-4.023-9.3Z"
              transform="translate(10 10)"
              fill="#fff"
            />
          </g>
          <g id="g1596" transform="translate(5.191 8.019)">
            <path
              id="path1598"
              d="M-6.836-9.3H-9.648A.352.352,0,0,1-10-9.648.352.352,0,0,1-9.648-10h2.812a.352.352,0,0,1,.352.352A.352.352,0,0,1-6.836-9.3Z"
              transform="translate(10 10)"
              fill="#fff"
            />
          </g>
          <g id="g1600" transform="translate(5.191 12.403)">
            <path
              id="path1602"
              d="M-4.023-9.3H-9.648A.352.352,0,0,1-10-9.648.352.352,0,0,1-9.648-10h5.625a.352.352,0,0,1,.352.352A.352.352,0,0,1-4.023-9.3Z"
              transform="translate(10 10)"
              fill="#fff"
            />
          </g>
          <g id="g1604" transform="translate(5.191 14.15)">
            <path
              id="path1606"
              d="M-6.836-9.3H-9.648A.352.352,0,0,1-10-9.648.352.352,0,0,1-9.648-10h2.812a.352.352,0,0,1,.352.352A.352.352,0,0,1-6.836-9.3Z"
              transform="translate(10 10)"
              fill="#fff"
            />
          </g>
          <g id="g1608" transform="translate(5.191 18.534)">
            <path
              id="path1610"
              d="M-4.023-9.3H-9.648A.352.352,0,0,1-10-9.648.352.352,0,0,1-9.648-10h5.625a.352.352,0,0,1,.352.352A.352.352,0,0,1-4.023-9.3Z"
              transform="translate(10 10)"
              fill="#fff"
            />
          </g>
          <g id="g1612" transform="translate(5.191 20.282)">
            <path
              id="path1614"
              d="M-6.836-9.3H-9.648A.352.352,0,0,1-10-9.648.352.352,0,0,1-9.648-10h2.812a.352.352,0,0,1,.352.352A.352.352,0,0,1-6.836-9.3Z"
              transform="translate(10 10)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Motivation_Svg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="dream" transform="translate(0)">
      <path
        id="Path_4332"
        data-name="Path 4332"
        d="M158.631,158.043l-1.682.327a1.219,1.219,0,0,0-.66,2.031l1.169,1.253a.176.176,0,0,1,.046.142l-.209,1.7a1.223,1.223,0,0,0,1.073,1.363,1.2,1.2,0,0,0,.136.008,1.224,1.224,0,0,0,.517-.116l1.553-.724a.177.177,0,0,1,.15,0l1.553.724A1.219,1.219,0,0,0,164,163.5l-.209-1.7a.176.176,0,0,1,.046-.142l1.169-1.253a1.219,1.219,0,0,0-.66-2.031l-1.682-.327a.176.176,0,0,1-.121-.088l-.83-1.5a1.219,1.219,0,0,0-2.135,0l-.83,1.5A.176.176,0,0,1,158.631,158.043Zm1.034.418.83-1.5a.177.177,0,0,1,.31,0l.83,1.5a1.218,1.218,0,0,0,.835.607l1.682.327a.177.177,0,0,1,.1.294l-1.169,1.253a1.218,1.218,0,0,0-.319.981l.209,1.7a.177.177,0,0,1-.25.182l-1.553-.724a1.217,1.217,0,0,0-1.032,0l-1.553.724a.177.177,0,0,1-.25-.182l.209-1.7a1.218,1.218,0,0,0-.319-.981l-1.169-1.253a.177.177,0,0,1,.1-.294l1.682-.327a1.218,1.218,0,0,0,.835-.607Z"
        transform="translate(-148.65 -148.524)"
        fill="#fff"
      />
      <path
        id="Path_4333"
        data-name="Path 4333"
        d="M49.889,57.59a.521.521,0,0,0,.624-.393,8.9,8.9,0,0,1,6.678-6.678.522.522,0,0,0-.231-1.018A9.926,9.926,0,0,0,49.5,56.965.522.522,0,0,0,49.889,57.59Z"
        transform="translate(-47.163 -47.168)"
        fill="#fff"
      />
      <path
        id="Path_4334"
        data-name="Path 4334"
        d="M57.19,296.469a8.9,8.9,0,0,1-6.678-6.679.522.522,0,0,0-1.018.231,9.926,9.926,0,0,0,7.465,7.465.522.522,0,0,0,.231-1.018Z"
        transform="translate(-47.161 -275.819)"
        fill="#fff"
      />
      <path
        id="Path_4335"
        data-name="Path 4335"
        d="M297.091,289.4a.522.522,0,0,0-.624.393,8.9,8.9,0,0,1-6.678,6.678.522.522,0,1,0,.231,1.018,9.926,9.926,0,0,0,7.465-7.465A.522.522,0,0,0,297.091,289.4Z"
        transform="translate(-275.817 -275.823)"
        fill="#fff"
      />
      <path
        id="Path_4336"
        data-name="Path 4336"
        d="M289.793,50.518a8.9,8.9,0,0,1,6.678,6.678.522.522,0,1,0,1.018-.231,9.926,9.926,0,0,0-7.465-7.465.522.522,0,1,0-.231,1.018Z"
        transform="translate(-275.822 -47.168)"
        fill="#fff"
      />
      <path
        id="Path_4337"
        data-name="Path 4337"
        d="M245.395,5.218a.522.522,0,0,0,.522-.522V.522a.522.522,0,0,0-1.043,0V4.7A.522.522,0,0,0,245.395,5.218Z"
        transform="translate(-233.395)"
        fill="#fff"
      />
      <path
        id="Path_4338"
        data-name="Path 4338"
        d="M245.389,400.693a.522.522,0,0,0-.522.522v4.174a.522.522,0,0,0,1.043,0v-4.174A.522.522,0,0,0,245.389,400.693Z"
        transform="translate(-233.389 -381.91)"
        fill="#fff"
      />
      <path
        id="Path_4339"
        data-name="Path 4339"
        d="M405.39,244.873h-4.174a.522.522,0,1,0,0,1.043h4.174a.522.522,0,1,0,0-1.043Z"
        transform="translate(-381.911 -233.395)"
        fill="#fff"
      />
      <path
        id="Path_4340"
        data-name="Path 4340"
        d="M5.218,245.389a.522.522,0,0,0-.522-.522H.522a.522.522,0,0,0,0,1.043H4.7A.522.522,0,0,0,5.218,245.389Z"
        transform="translate(0 -233.389)"
        fill="#fff"
      />
    </g>
  </svg>
);

export const Diet_Svg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="21.943"
    viewBox="0 0 24 21.943"
  >
    <g id="diet" transform="translate(0 -21.946)">
      <g id="Group_2536" data-name="Group 2536" transform="translate(0 21.946)">
        <g id="Group_2535" data-name="Group 2535" transform="translate(0 0)">
          <path
            id="Path_4341"
            data-name="Path 4341"
            d="M112.248,49.775c2.6,0,3.344,1.821,3.513,3.349a.379.379,0,0,0,.376.337l.042,0a.379.379,0,0,0,.335-.418,5.174,5.174,0,0,0-.939-2.544,3.946,3.946,0,0,0-3.327-1.48.379.379,0,1,0,0,.758Z"
            transform="translate(-106.625 -47.748)"
            fill="#fff"
          />
          <path
            id="Path_4342"
            data-name="Path 4342"
            d="M227.066,26.733a3.561,3.561,0,0,0,1.009.143h0a4.234,4.234,0,0,0,2.68-1,4.086,4.086,0,0,0,1.532-3.463.379.379,0,0,0-.27-.326,3.563,3.563,0,0,0-1.009-.143,4.234,4.234,0,0,0-2.68,1,4.086,4.086,0,0,0-1.532,3.463A.379.379,0,0,0,227.066,26.733Zm1.745-3.205a3.475,3.475,0,0,1,2.2-.824,2.877,2.877,0,0,1,.538.05,3.385,3.385,0,0,1-1.274,2.54,3.475,3.475,0,0,1-2.2.824,2.881,2.881,0,0,1-.538-.05A3.385,3.385,0,0,1,228.811,23.528Z"
            transform="translate(-216.149 -21.946)"
            fill="#fff"
          />
          <path
            id="Path_4343"
            data-name="Path 4343"
            d="M23.621,141.187H19.085V139.3a.379.379,0,0,0-.379-.379h-.4a6.832,6.832,0,0,0-1.12-2.458,4.464,4.464,0,0,0-3.4-1.937,3.768,3.768,0,0,0-1.338.254,9.1,9.1,0,0,1-2.77.759H9.635a.172.172,0,0,0-.186,0H9.4a9.1,9.1,0,0,1-2.77-.759,3.768,3.768,0,0,0-1.338-.254,4.463,4.463,0,0,0-3.4,1.937,6.832,6.832,0,0,0-1.12,2.458h-.4A.379.379,0,0,0,0,139.3v4.536a.379.379,0,0,0,.379.379h.647a17.443,17.443,0,0,0,2.334,5.08c1.871,2.671,3.789,1.839,4.333,1.521a5.257,5.257,0,0,1,1.585-.418h.529a5.24,5.24,0,0,1,1.585.418,2.783,2.783,0,0,0,1.382.377,3.656,3.656,0,0,0,2.951-1.9,16.36,16.36,0,0,0,1.534-2.812h3.588a.379.379,0,1,0,0-.758h-3.28l.02-.054q.054-.143.106-.289l.027-.075q.053-.152.1-.306l.015-.046q.054-.165.1-.332l.015-.05q.049-.162.094-.327l.009-.032h.647a.379.379,0,0,0,.379-.379v-1.889h.8v1.571a.379.379,0,1,0,.758,0v-1.571h.933v.893a.379.379,0,0,0,.758,0v-.893h.91v3.778H22.024a.379.379,0,1,0,0,.758h1.6A.379.379,0,0,0,24,146.1v-4.536A.379.379,0,0,0,23.621,141.187ZM2.511,136.9l.01-.014A3.744,3.744,0,0,1,5.3,135.282a3.013,3.013,0,0,1,1.069.205A9.688,9.688,0,0,0,9.4,136.3a1.3,1.3,0,0,0,.139-.007,1.306,1.306,0,0,0,.139.007,9.69,9.69,0,0,0,3.039-.808,3.014,3.014,0,0,1,1.069-.205,3.771,3.771,0,0,1,2.775,1.605l.01.014a6.04,6.04,0,0,1,.955,2.017H1.556A6.039,6.039,0,0,1,2.511,136.9Zm15.816,4.664v1.889h-2.7a.379.379,0,1,0,0,.758h1.646l-.016.055-.014.048q-.076.256-.162.513l-.009.027q-.184.549-.413,1.1v0a15.779,15.779,0,0,1-1.552,2.9c-1.458,2.082-2.813,1.6-3.329,1.3a5.976,5.976,0,0,0-1.9-.52l-.043,0H9.256l-.043,0a5.975,5.975,0,0,0-1.9.52c-.515.3-1.871.78-3.329-1.3a16.61,16.61,0,0,1-2.168-4.645H14.328a.379.379,0,1,0,0-.758H.758v-3.778h.732v1.479a.379.379,0,0,0,.758,0v-1.479h.933v.8a.379.379,0,0,0,.758,0v-.8h.933v1.479a.379.379,0,0,0,.758,0v-1.479h.933v.8a.379.379,0,0,0,.758,0v-.8h.933v1.479a.379.379,0,0,0,.758,0v-1.479h.933v.8a.379.379,0,0,0,.758,0v-.8h.933v1.479a.379.379,0,0,0,.758,0v-1.479h.933v.8a.379.379,0,0,0,.758,0v-.8h.933v1.479a.379.379,0,0,0,.758,0v-1.479h.933v.8a.379.379,0,0,0,.758,0v-.8h.859v1.889Z"
            transform="translate(0 -129.247)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const BackArrowWhite = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27.008"
    height="27.008"
    viewBox="0 0 27.008 27.008"
  >
    <g id="Arrow_Left" transform="translate(-35.992 -191.746)">
      <path
        id="Path_4288"
        data-name="Path 4288"
        d="M15,1.5a13.507,13.507,0,0,1,5.257,25.946A13.507,13.507,0,0,1,9.747,2.562,13.42,13.42,0,0,1,15,1.5Zm0,24.553A11.049,11.049,0,1,0,3.955,15,11.061,11.061,0,0,0,15,26.053Z"
        transform="translate(34.492 190.246)"
        fill="#fff"
      />
      <path
        id="Path_4289"
        data-name="Path 4289"
        d="M16.638,22.776a1.224,1.224,0,0,1-.868-.36L10.86,17.506a1.228,1.228,0,0,1,0-1.736L15.77,10.86A1.228,1.228,0,0,1,17.506,12.6l-4.042,4.042,4.042,4.042a1.228,1.228,0,0,1-.868,2.1Z"
        transform="translate(32.857 188.611)"
        fill="#fff"
      />
      <path
        id="Path_4290"
        data-name="Path 4290"
        d="M21.549,18.955H11.728a1.228,1.228,0,1,1,0-2.455h9.821a1.228,1.228,0,1,1,0,2.455Z"
        transform="translate(32.857 187.521)"
        fill="#fff"
      />
    </g>
  </svg>
);

export const Time_Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g
      id="Icon_feather-clock"
      data-name="Icon feather-clock"
      transform="translate(-1.5 -1.5)"
    >
      <path
        id="Path_4344"
        data-name="Path 4344"
        d="M9.5,1.5a8,8,0,0,1,3.114,15.371A8,8,0,0,1,6.386,2.129,7.95,7.95,0,0,1,9.5,1.5Zm0,14.545A6.545,6.545,0,1,0,2.955,9.5,6.553,6.553,0,0,0,9.5,16.045Z"
        fill="white"
      />
      <path
        id="Path_4345"
        data-name="Path 4345"
        d="M20.342,15.186A.765.765,0,0,1,20,15.1l-3.074-1.537a.769.769,0,0,1-.425-.687V8.269a.769.769,0,0,1,1.537,0V12.4l2.649,1.325a.769.769,0,0,1-.344,1.456Z"
        transform="translate(-7.882 -3.229)"
        fill="white"
      />
    </g>
  </svg>
);

export const Calory_Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.219"
    height="16"
    viewBox="0 0 14.219 16"
  >
    <g
      id="Icon_core-fire"
      data-name="Icon core-fire"
      transform="translate(-3.395 -1.35)"
    >
      <path
        id="Path_4344"
        data-name="Path 4344"
        d="M12.216,9.35c.185-.3.375-.616.564-.94a3.635,3.635,0,0,0,.344-3.238C12.312,3.019,9.6,1.707,8.97,1.5L8.528,1.35,7.839,2.729,8.171,3a1.266,1.266,0,0,1,.4.815,1.864,1.864,0,0,1-.681,1.342c-.328.328-.689.646-1.07.982-1.6,1.413-3.424,3.016-3.424,6.047q0,.062,0,.124a5.079,5.079,0,0,0,1.559,3.573A5.174,5.174,0,0,0,8.573,17.35h3.091l-.382-.774C9.732,13.43,10.828,11.629,12.216,9.35ZM8.573,16.276a4.1,4.1,0,0,1-4.1-3.985q0-.052,0-.1c0-2.546,1.556-3.917,3.06-5.242.377-.332.767-.676,1.119-1.028a2.864,2.864,0,0,0,.994-2.155A2.18,2.18,0,0,0,9.4,2.871a6,6,0,0,1,2.719,2.68,2.577,2.577,0,0,1-.267,2.318c-.183.314-.372.623-.553.922C9.967,10.979,8.7,13.053,9.975,16.276Z"
        transform="translate(0)"
        fill="white"
      />
      <path
        id="Path_4345"
        data-name="Path 4345"
        d="M27.03,19.641q-.013-.053-.028-.107c-.387-1.421-2.532-3.247-2.775-3.451l-.488-.409-.32.551a12.569,12.569,0,0,0-1.629,3.7,7.2,7.2,0,0,0,.641,4.6l.144.313h.365a4.2,4.2,0,0,0,3.332-1.628A4.133,4.133,0,0,0,27.03,19.641ZM25.423,22.55a3.131,3.131,0,0,1-2.162,1.2c-1.058-2.547-.434-4.283.759-6.413a7.5,7.5,0,0,1,1.946,2.482q.012.043.022.086a3.066,3.066,0,0,1-.565,2.648Z"
        transform="translate(-9.542 -7.488)"
        fill="white"
      />
    </g>
  </svg>
);
